import React, { Fragment } from 'react';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import { history } from 'store';
import ProjectList from 'components/Agile/project/projectList';
import ProjectDetail from 'components/Agile/project/projectDetail';
import ProjectAdd from 'components/Agile/project/projectAdd';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';

export class Component extends React.Component {

    addFavouriteProject = (data) => {
        this.props.addFavouriteProject(data);
    };
    onProjectSelect = (data) => {
        this.props.onProjectSelect(data);
    };
    onAddProject = () => {
        this.props.onAddProject();
    };
    onProjectClose = () => {
        this.props.onProjectClose();
    };
    onFilterProjectOptionSelect = (option) => {
        this.props.onFilterProjectOptionSelect(option);
    };
    onSaveProject = (data) => {
        this.props.onSaveProject(data);
    };
    onDeleteProject = (data) => {
        this.props.onDeleteProject(data);
    };
    onDeleteSelectedProject = () => {
        this.props.onDeleteSelectedProject();
    };
    filterProject = (projectName) => {
        if (projectName === '') {
            this.onFilterProjectOptionSelect(this.props.filterOption);
        } else {
            this.props.filterProject(projectName);
        }
    };
    handleProjectRequestClose = () => {
        this.props.handleProjectRequestClose();
    };
    getAllProject = () => {
        this.props.getAllProject();
    };
    getUnselectedAllProject = () => {
        this.props.getUnselectedAllProject();
    };
    onAllProjectSelect = () => {
        const selectAll = this.props.selectedProjects < this.props.projectList.length;
        if (selectAll) {
            this.props.getAllProject();
        } else {
            this.props.getUnselectedAllProject();
        }
    };
    onToggleProjectDrawer = () => {
        this.props.onToggleProjectDrawer();
    };
    showProjectLoader = () => {
        this.props.showProjectLoader();
    }

    constructor() {
        super();
    }
    componentDidMount() {
        const { selectedOrg, showProjectLoader, fetchProjects, fetchInitiatives } = this.props;
        showProjectLoader();
        fetchProjects({ orgid: selectedOrg?.id, useCache: true });
        fetchInitiatives();
    }
    updateSearchProject(evt) {
        this.props.updateSearchProject(evt.target.value);
        this.props.filterProject(evt.target.value);
    }
    onProjectPrioritiesDashboard = (data) => {
        this.props.onProjectPrioritiesDashboard(data);
    };
    onProjectCostPrioritiesDashboard = (data) => {
        this.props.onProjectCostPrioritiesDashboard(data);
    };
    onProjectBusinessPrioritiesDashboard = (data) => {
        this.props.onProjectBusinessPrioritiesDashboard(data);
    };
    onProjectIssuesDashboard = (data) => {
        this.props.onProjectIssuesDashboard(data);
    };

    onGlobalProjectCostPrioritiesDashboard = () => {
        const { projectList } = this.props;
        const selectedProject = projectList?.length > 0 ? projectList[0] : [];
        const payload = (selectedProject && selectedProject?.costImplPriorityParams?.length > 0) ? selectedProject.costImplPriorityParams : [];
        this.props.onProjectPrioritiesDashboard(selectedProject);
        this.props.onGlobalProjectCostPrioritiesDashboard(payload);
        history.push('/app/projectPriority/default');
    }
    onGlobalProjectBusinessPrioritiesDashboard = () => {
        const { projectList } = this.props;
        const selectedProject = projectList?.length > 0 ? projectList[0] : [];
        const payload = (selectedProject && selectedProject?.busValPriorityParams?.length > 0) ? selectedProject.busValPriorityParams : [];
        this.props.onProjectPrioritiesDashboard(selectedProject);
        this.props.onGlobalProjectBusinessPrioritiesDashboard(payload);
        history.push('/app/projectPriority/default');
    }

    fetchImportProjects = (id) => {
        this.props.showImportProjectsLoader();
        this.props.fetchImportProjects(id);
    }

    onImportProjects = () => {
        this.props.showProjectLoader();
        this.props.showImportProjectsLoader();
        this.props.onImportProjects();
    }
    setProject = (id) => {
        this.props.setProject(id);
    }

    projectSideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.projects" /></span>
                </div>
            </div>
            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                        
                    {/* DO NOT ADD PROJECTS HERE - ADD VIA JIRA - THEY ARE IMPORTED TO DYNAMODB AND CAN EDIT
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={this.onAddProject}>
                            <i className="zmdi zmdi-plus-circle-o zmdi-hc-fw" />
                            <span><IntlMessages id="project.addProject" /></span>
                        </Button>
                    </div> */}
                    {/* Prioirties moved to their own tables - dont update the old way
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={this.onGlobalProjectCostPrioritiesDashboard}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span><IntlMessages id="project.updateProjectCostPriorities" /></span>
                        </Button>
                    </div>
                    <div className="module-add-task" style={{ marginTop: '-40px' }}>
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={this.onGlobalProjectBusinessPrioritiesDashboard}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span><IntlMessages id="project.updateProjectBusinessPriorities" /></span>
                        </Button>
                    </div> */}
                </CustomScrollbars>
            </div>
        </div>;
    };

    render() {
        const {
            width,
            project,
            projectList,
            addProjectState,
            alertMessage,
            showMessage,
            drawerState,
            noContentFoundMessage,
            loader,
            selectedOrg,
            selectedProject,
            allInitiative,
        } = this.props;
        return (
            <div className="app-wrapper">
                <div className="app-module animated slideInUpTiny animation-duration-3">
                    <div className="d-block d-xl-none">
                        <Drawer
                            touch={true}
                            transitions={true}
                            enableDragHandle={true}
                            open={drawerState}
                            onOpenChange={this.onToggleProjectDrawer.bind(this)}
                            sidebar={this.projectSideBar(project)} />
                    </div>
                    <div className="app-module-sidenav d-none d-xl-flex">
                        {this.projectSideBar(project)}
                    </div>
                    <div className="module-box">
                        <div className="module-box-content">
                            <div className="module-box-header">
                                <span className="icon-btn drawer-btn d-flex d-xl-none"
                                    onClick={this.onToggleProjectDrawer.bind(this)}>
                                    <i className="zmdi zmdi-menu" />
                                </span>
                                <div className="d-flex align-items-center justify-content-center" style={{ padding: 10 }}>
                                    NOTE - This dashboard uses data that may be cached for up to 24 hours&nbsp;&nbsp;&nbsp;
                                    <Button className="jr-btn jr-btn-sm btn-primary text-white mb-0" color="primary"
                                        onClick={() => {
                                            this.props.showProjectLoader();
                                            this.props.fetchProjects({ orgid: selectedOrg?.id, useCache: false }); // DONT use the cache
                                        }}
                                    >
                                        Refresh Now
                                    </Button>
                                </div>
                            </div>
                            <div className="module-box-topbar">
                            </div>
                            <CustomScrollbars className="module-list-scroll scrollbar"
                                style={{ height: width >= 1200 ? 'calc(105vh - 265px)' : 'calc(105vh - 245px)' }}>
                                {loader ?
                                    <div
                                        className="loader-view-block h-100">
                                        <div className="loader-view">
                                            <CircularProgress />
                                        </div>
                                    </div>
                                    :
                                    projectList && projectList.length > 0 ?
                                        <Fragment>
                                            <ProjectList
                                                selected={projectList.findIndex(entry => entry?.id === selectedProject?.id) || 0}
                                                data={projectList}
                                                width={width}
                                                setProject={this.setProject.bind(this)} />
                                            <div style={{ marginTop: 10 }}>
                                                <ProjectDetail
                                                    projectList={projectList}
                                                    selectedProject={selectedProject}
                                                    width={width}
                                                    setProject={this.setProject.bind(this)}
                                                    onProjectPrioritiesDashboard={this.onProjectPrioritiesDashboard.bind(this)}
                                                    onProjectCostPrioritiesDashboard={this.onProjectCostPrioritiesDashboard.bind(this)}
                                                    onProjectBusinessPrioritiesDashboard={this.onProjectBusinessPrioritiesDashboard.bind(this)}
                                                    onProjectIssuesDashboard={this.onProjectIssuesDashboard.bind(this)}
                                                    onProjectSelect={this.onProjectSelect.bind(this)}
                                                    onDeleteProject={this.onDeleteProject.bind(this)}
                                                    onSaveProject={this.onSaveProject.bind(this)}
                                                    showProjectLoader={this.showProjectLoader.bind(this)}
                                                    initiatives={allInitiative}
                                                />
                                            </div>
                                        </Fragment>
                                        :
                                        <div className="h-100 d-flex align-items-center justify-content-center">
                                            {noContentFoundMessage}
                                        </div>
                                }
                            </CustomScrollbars>

                        </div>
                    </div>
                </div>
                <ProjectAdd
                    open={addProjectState}
                    project={{
                        'id': '',
                        'orgid': '',
                        'name': '',
                        'description': '',
                        'startDate': '',
                        'endDate': '',
                        'weight': 0,
                        'jiraProjectAttributes': {},
                        'costImplPriorityParams': [],
                        'busValPriorityParams': [],
                        'budget': 0,
                        'initiative': '',
                        'businessValue': '',
                        'thumb': null,
                        'starred': false,
                        'selected': false,
                        'frequently': false
                    }}
                    onSaveProject={this.onSaveProject}
                    onProjectClose={this.onProjectClose}
                    onDeleteProject={this.onDeleteProject}
                    showProjectLoader={this.showProjectLoader}
                    initiatives={allInitiative}
                />

                {showMessage && NotificationManager.success(alertMessage, this.handleProjectRequestClose())}
                <NotificationContainer />

            </div>
        );
    }
}

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/project/component.js